import {
  FETCH_INVOICELIST_REQUEST,
  FETCH_INVOICELIST_SUCCESS,
  FETCH_INVOICELIST_FAILURE,
} from "./invoiceListTypes";

const initialState = {
  loading: false,
  invoiceList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVOICELIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_INVOICELIST_SUCCESS:
      return {
        loading: false,
        invoiceList: action.payload,
        error: "",
      };
    case FETCH_INVOICELIST_FAILURE:
      return {
        loading: false,
        invoiceList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
